import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import {
  TreeTable,
  TreeTableExpandedKeysType,
  TreeTableRowMouseEvent,
} from "primereact/treetable";
import { useEffect, useState } from "react";
import { TreeNode } from "primereact/treenode";
import { Button } from "primereact/button";
import { useCampusActivities } from "../../../api/queries/enum/useCampusActivities";

export default function CampusActivitiesList() {
  const navigate = useNavigate();

  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<TreeTableExpandedKeysType>();

  const { data: campusActivitiesResponse, isLoading } = useCampusActivities(); // flat

  const onRowClick = ({ node }: TreeTableRowMouseEvent) => {
    navigate(`/admin/campus-activities/${node.data.id}`);
  };

  useEffect(() => {
    if (!campusActivitiesResponse) return;

    const activities = campusActivitiesResponse.data.results;
    const newNodes: TreeNode[] = [];

    const getChildren = (nodeId: string): TreeNode[] => {
      return activities
        .filter((item) => item.parent?.id === nodeId)
        .map((item) => ({
          id: item.id,
          key: item.id,
          label: item.name,
          data: item,
          expanded: true,
          children: getChildren(item.id),
        }));
    };

    activities.forEach((item) => {
      if (item.parent === null) {
        newNodes.push({
          id: item.id,
          key: item.id,
          label: item.name,
          data: item,
          expanded: true,
          children: getChildren(item.id),
        });
      }
    });

    setNodes(newNodes);
  }, [campusActivitiesResponse]);

  useEffect(() => {
    if (!campusActivitiesResponse) return;

    const keys: TreeTableExpandedKeysType = {};

    campusActivitiesResponse.data.results.forEach((item) => {
      keys[item.id] = true;
    });

    setExpandedKeys(keys);
  }, [campusActivitiesResponse]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Campus activities</h1>

        <Button
          onClick={() => navigate("/admin/campus-activities/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <TreeTable
        emptyMessage={"No records"}
        lazy={false}
        paginator={false}
        loading={isLoading}
        className="p-datatable-sm p-datatable-pointer"
        stripedRows={true}
        value={nodes}
        expandedKeys={expandedKeys} // FIXME
        onRowClick={onRowClick}
      >
        <Column header={"Name"} field={"name"} expander />
      </TreeTable>
    </div>
  );
}
